import { useEffect, useState } from 'react'

import { Button } from 'components/ui/Button/Button'
import { IconButton } from 'components/ui/Button/IconButton/IconButton'
import { Checkbox } from 'components/ui/Checkbox/Checkbox'
import { Slider } from 'components/ui/Slider/Slider'
import { Product } from 'services/warehouse-containers/filters/store'

export interface FilterProp {
  onSelect?: (value: Product[]) => void
  values: Product[]
  checked?: Product[]
}

export const ProductFilter: React.FC<FilterProp> = ({
  values,
  checked = [],
  onSelect,
}: FilterProp) => {
  const [isActive, setIsActive] = useState<boolean>(false)
  const [selected, setSelected] = useState<Product[]>(values)
  const [text, setText] = useState<string>('Продукт')

  useEffect(() => {
    setSelected(values)
    onSelect?.(values)
  }, [values])

  useEffect(() => {
    if (!checked?.length) {
      setText('Продукт')
      return
    }

    setText(`Продукт (${checked?.length})`)
  }, [checked?.length])

  const handleOnSubmit = () => {
    setIsActive(true)
  }

  const handleFilterSumbit = () => {
    setIsActive(false)
    onSelect?.(selected)
  }

  const handleFilterCancelSubmit = () => {
    setIsActive(false)
    setSelected(checked)
  }

  const renderItem = (value: Product, index: number) => {
    const handleOnMark = (isChecked: boolean) => {
      setSelected((curr: Product[]) => {
        const uniq = new Set([...curr, value])

        if (!isChecked) uniq.delete(value)

        return [...uniq.values()]
      })
    }

    // NOTE: Вопрос как тут сделать нормальнов вообще?
    // Как делают люди?
    return (
      <div key={index} className="filter-product-item">
        <Checkbox checked={selected?.includes(value)} onChange={handleOnMark} />
        <span className="filter-product-item-text">{value.title}</span>
      </div>
    )
  }

  return (
    <>
      <IconButton title={text} icon="arrow" outline round onSubmit={handleOnSubmit}></IconButton>
      <Slider isActive={isActive} onClose={handleFilterCancelSubmit} height="550px">
        <div className="filter-wheel__slider">
          <h2>Фильтр по продуктам</h2>
          <div className="filter-wheel__slider-items">{values?.map(renderItem)}</div>
          <div className="filter-wheel__slider_controlls flex-center">
            <span style={{ marginRight: '0.5rem' }}>
              <Button title="Применить" handleOnSubmit={handleFilterSumbit}></Button>
            </span>
            <Button title="Отменить" outline handleOnSubmit={handleFilterCancelSubmit}></Button>
          </div>
        </div>
      </Slider>
    </>
  )
}
